module.exports = __webpack_public_path__ + "static/media/image.6df8c8c0.png";